"use client";
import { useAtom } from "jotai";
import { Suspense, useEffect } from "react";
import NProgress from "nprogress";
import { progressAtom, serverLoadingAtom } from "../headerHooks";
import { usePathname, useSearchParams } from "next/navigation";
import useIsClient from "../useIsClient";

function useRouterConfig() {
  const [routerProgress, setRouterProgress] = useAtom(progressAtom);
  const [, setServerLoading] = useAtom(serverLoadingAtom);
  NProgress.configure({ easing: "ease", showSpinner: false });
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const handleRouteStart = () => {
    NProgress.start();
  };
  const handleRouteDone = () => {
    NProgress.done();
  };
  useEffect(() => {
    routerProgress ? handleRouteStart() : handleRouteDone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routerProgress]);
  useEffect(() => {
    setRouterProgress(false);
    setServerLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, searchParams]);

  // useEffect(() => {
  //   Router.events.on("routeChangeStart", handleRouteStart);
  //   Router.events.on("routeChangeComplete", handleRouteDone);
  //   Router.events.on("routeChangeError", handleRouteDone);

  //   return () => {
  //     Router.events.off("routeChangeStart", handleRouteStart);
  //     Router.events.off("routeChangeComplete", handleRouteDone);
  //     Router.events.off("routeChangeError", handleRouteDone);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
}

const RouterEventsHand = () => {
  useRouterConfig();
  return <></>;
};

/**
 * Using `useSearchParams` in SSG will cause the tree up to the closest `Suspense` to be client-side rendered.
 * You don't want that. Hence we need to wrap usage of `useOnComplete` inside `Suspense`. *Only* this
 * `__RouterEvents` component is client-side rendered, the rest is kept intact.
 *
 * However, if you don't use `useSearchParams` in `useOnComplete` above, you can simply import and use
 * `useOnComplete` in `app/layout.client.tsx` directly.
 */

export function RouterEvents() {
  const isClient = useIsClient();
  return isClient ? (
    <Suspense>
      <RouterEventsHand />
    </Suspense>
  ) : null;
}
